var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9203 4.1333C19.507 4.1333 17.347 5.30663 16.0003 7.10663C14.6537 5.30663 12.4937 4.1333 10.0803 4.1333C5.98699 4.1333 2.66699 7.46663 2.66699 11.5866C2.66699 13.1733 2.92033 14.64 3.36033 16C5.46699 22.6666 11.9603 26.6533 15.1737 27.7466C15.627 27.9066 16.3737 27.9066 16.827 27.7466C20.0403 26.6533 26.5337 22.6666 28.6403 16C29.0803 14.64 29.3337 13.1733 29.3337 11.5866C29.3337 7.46663 26.0137 4.1333 21.9203 4.1333Z",
    fill: "#1F2830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartMenu);
export default __webpack_public_path__ + "static/media/heart-menu.466c5b32100f689b6d7d4e1384b81b2e.svg";
export { ForwardRef as ReactComponent };